import axios from "axios";
import { API_BE4FE_URL } from "../config";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

export const GET_AGGREGATED_PRODUCTS_START = "GET_AGGREGATED_PRODUCTS_START";
export const GET_AGGREGATED_PRODUCTS_SUCCESS =
    "GET_AGGREGATED_PRODUCTS_SUCCESS";
export const GET_AGGREGATED_PRODUCTS_ERROR = "GET_AGGREGATED_PRODUCTS_ERROR";
export const BUY_COMPANY_AGGREGATED_PRODUCTS_START =
    "BUY_COMPANY_AGGREGATED_PRODUCTS_START";
export const BUY_COMPANY_AGGREGATED_PRODUCTS_SUCCESS =
    "BUY_COMPANY_AGGREGATED_PRODUCTS_SUCCESS";
export const BUY_COMPANY_AGGREGATED_PRODUCTS_ERROR =
    "BUY_COMPANY_AGGREGATED_PRODUCTS_ERROR";
export const GET_PRODUCTS_START = "GET_PRODUCTS_START";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";
export const GET_COMPANY_PRODUCTS_START = "GET_COMPANY_PRODUCTS_START";
export const GET_COMPANY_PRODUCTS_SUCCESS = "GET_COMPANY_PRODUCTS_SUCCESS";
export const GET_COMPANY_PRODUCTS_ERROR = "GET_COMPANY_PRODUCTS_ERROR";
export const BUY_COMPANY_PRODUCT_START = "BUY_COMPANY_PRODUCT_START";
export const BUY_COMPANY_PRODUCT_SUCCESS = "BUY_COMPANY_PRODUCT_SUCCESS";
export const BUY_COMPANY_PRODUCT_ERROR = "BUY_COMPANY_PRODUCT_ERROR";

export const getAggregatedProducts = () => {
    return (dispatch: any) => {
        return new Promise(function (resolve, reject) {
            dispatch({ type: GET_AGGREGATED_PRODUCTS_START });

            axios
                .get(`${API_BE4FE_URL}/products/aggregated`, {
                    headers: dispatch(createHttpHeaderWithAuthorization(true)),
                })
                .then((result) => {
                    dispatch({
                        type: GET_AGGREGATED_PRODUCTS_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_AGGREGATED_PRODUCTS_ERROR });
                    reject(e);
                });
        });
    };
};

export const getProducts = () => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_PRODUCTS_START });
            axios
                .get(`${API_BE4FE_URL}/products?itemId=${itemId}`, {
                    headers: dispatch(createHttpHeaderWithAuthorization(true)),
                })
                .then((result) => {
                    dispatch({
                        type: GET_PRODUCTS_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_PRODUCTS_ERROR });
                    reject(e);
                });
        });
    };
};

export const getCompanyProducts = (fiscalCode: string) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_COMPANY_PRODUCTS_START });
            axios
                .get(
                    `${API_BE4FE_URL}/companies/fiscal_code/${fiscalCode}/products?itemId=${itemId}`,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: GET_COMPANY_PRODUCTS_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: "GET_COMPANY_PRODUCTS_ERROR" });
                    reject(e);
                });
        });
    };
};

export const buyCompanyAggregatedProducts = (
    fiscalCode: string,
    products: string[],
) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;

            dispatch({ type: BUY_COMPANY_AGGREGATED_PRODUCTS_START });

            const payload = {
                itemId: itemId,
                products: products,
            };

            axios
                .post(
                    `${API_BE4FE_URL}/companies/${fiscalCode}/aggregatedProducts?itemId=${itemId}`,
                    payload,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: BUY_COMPANY_AGGREGATED_PRODUCTS_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: BUY_COMPANY_AGGREGATED_PRODUCTS_ERROR });
                    reject(e);
                });
        });
    };
};

export const buyCompanyProduct = (
    fiscalCode: string,
    product: string,
    balanceType: any,
    balanceYear: any,
    startDate?: any,
    endDate?: any,
    kDoc?: any,
) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: BUY_COMPANY_PRODUCT_START });
            let buyProductBody = {};
            if (
                product === "BILANCIO_COMPLETO" ||
                product === "BILANCIO_XBRL"
            ) {
                buyProductBody = {
                    year: balanceYear,
                    is_consolidated: balanceType === "consolidated",
                };
            }
            if (product === "LISTA_ATTI_TRASFERIMENTI_AZIENDA") {
                buyProductBody = {
                    start_date: startDate,
                    end_date: endDate,
                };
            }
            if (product === "ATTO_TRASFERIMENTI_AZIENDA") {
                buyProductBody = {
                    kdoc: kDoc,
                };
            }
            axios
                .post(
                    `${API_BE4FE_URL}/companies/${fiscalCode}/products/${product}?itemId=${itemId}`,
                    buyProductBody,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: BUY_COMPANY_PRODUCT_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: BUY_COMPANY_PRODUCT_ERROR });
                    reject(e);
                });
        });
    };
};
